/** Verbose Everyman ↔ PU iframe logs. Never log tokens. */
export const isEverymanDtraderDebugEnabled = (): boolean => {
    if (typeof window === 'undefined') return false;
    try {
        if (localStorage.getItem('debug_everyman_dtrader') === '1') return true;
        return new URLSearchParams(window.location.search).get('debug_everyman_dtrader') === '1';
    } catch {
        return false;
    }
};

export const everymanDtraderDebugLog = (scope: string, payload: Record<string, unknown>): void => {
    if (!isEverymanDtraderDebugEnabled()) return;
    // eslint-disable-next-line no-console
    console.info(`[Everyman][${scope}]`, payload);
};
